<div>
  <mat-card-header>
    <div style="width:90%">
      <mat-card-title>
        <label style="padding-top: 15px; font-size: 20px; font-weight: 500; color: #434a54;">Histórico Protocolo -
          {{status.idProtocolo}} </label>
      </mat-card-title>
    </div>
    <div style="width:10%; cursor:pointer;">
      <mat-icon class="btnCancel" style="position: relative; float: right; margin-right: 5px" (click)="cancelar()">cancel</mat-icon>
    </div>
  </mat-card-header>
  <form>    
    <div class="table">
      <div class="table-container">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef> Usuário </th>
            <td mat-cell *matCellDef="let row"> {{row.usuario}} </td>
          </ng-container>
          <ng-container matColumnDef="dataStatus">
            <th mat-header-cell *matHeaderCellDef> Data </th>
            <td mat-cell *matCellDef="let row"> {{row.dataStatus | date: 'dd/MM/yyyy - HH:mm:ss' }} </td>
          </ng-container>
          <ng-container matColumnDef="acao">
            <th mat-header-cell *matHeaderCellDef> Ação </th>
            <td mat-cell *matCellDef="let row"> {{row.acao}} </td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef> Detalhes </th>
            <td mat-cell *matCellDef="let row"> {{row.descricao}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div *ngIf="status.registros.length === 0"><br />Não há registros para serem exibidos</div>
      <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
    </div>
  </form>
</div>